import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError, describeError } from '../lib/api';
import { Button } from '../components/ui';
import { Field, Notice, PasswordInput } from '../components/form';

/** 重置口令：token 来自邮件链接；成功后所有会话与刷新令牌都会失效。 */
export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit() {
    if (password !== confirm) {
      setError('两次输入的口令不一致');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/auth/password/reset', { token, newPassword: password });
      setDone(true);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : describeError(caught));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-[420px] space-y-4">
        <h1 className="text-[28px] font-semibold text-fg">设置新口令</h1>

        {token === '' ? (
          <Notice tone="danger">链接缺少令牌，请从邮件中重新打开。</Notice>
        ) : error ? (
          <Notice tone="danger">{error}</Notice>
        ) : null}

        {done ? (
          <>
            <Notice tone="ok">口令已更新。出于安全考虑，所有设备上的登录都已失效，请重新登录。</Notice>
            <Link to="/login" className="block">
              <Button variant="primary" block>
                去登录
              </Button>
            </Link>
          </>
        ) : (
          <>
            <Field label="新口令" htmlFor="password" hint="至少 10 位，包含字母与数字" required>
              <PasswordInput
                id="password"
                value={password}
                onChange={setPassword}
                autoComplete="new-password"
              />
            </Field>
            <Field label="确认新口令" htmlFor="confirm" required>
              <PasswordInput
                id="confirm"
                value={confirm}
                onChange={setConfirm}
                autoComplete="new-password"
              />
            </Field>
            <Button
              variant="primary"
              block
              loading={busy}
              disabled={token === ''}
              onClick={submit}
            >
              更新口令
            </Button>
          </>
        )}

        <p className="text-center text-[13px] text-fg-muted">
          <Link to="/login" className="text-brand hover:underline">
            返回登录
          </Link>
        </p>
      </div>
    </div>
  );
}
